import { Injectable } from "@angular/core";
import { TabCanceler } from "./tab-canceler.service";

@Injectable({
  providedIn: 'root'
})
export class ChromeTabCanceler extends TabCanceler {

  mustBeCanceled() {
    const match = /^chrome:/g;
    return match.test(this.url.protocol);
  }

}
